import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import SearchIcon from '@material-ui/icons/Search';

interface Props {
  numberOfWidgets: number;
}

function LayoutReference({ numberOfWidgets }: Props) {
  const classes = useStyles();
  const numberArray = Array(numberOfWidgets).fill(null);

  return (
    <div className={classes.root}>
      <div className={classes.searchBar}>
        <SearchIcon className={classes.searchIcon} />
        Search Bar
      </div>
      <div className={classes.blocksContainer}>
        {numberArray.map((_, index) => (
          <div className={classes.block} key={`layout-position-${index}`}>
            <div className={classes.positionText}>Position {index + 1}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

const useStyles = makeStyles(theme => {
  const boxBackground = '#E0E6EF';
  const borderRadius = theme.spacing(0.5);

  return {
    root: {
      width: '100%',
    },
    searchBar: {
      backgroundColor: boxBackground,
      marginBottom: theme.spacing(),
      borderRadius,
      height: 26,
      display: 'flex',
      alignItems: 'center',
    },
    searchIcon: {
      fontSize: 16,
      marginLeft: theme.spacing(0.75),
      marginRight: theme.spacing(0.5),
    },
    block: {
      backgroundColor: boxBackground,
      flex: '0 1 calc(33.333% - 5.4px)',
      borderRadius,
      height: 96,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    positionText: {
      backgroundColor: theme.palette.common.white,
      borderRadius,
      textAlign: 'center',
      padding: theme.spacing(0.5),
    },
    blocksContainer: {
      display: 'flex',
      gap: `${theme.spacing()}px`,
      flexWrap: 'wrap',
    },
  };
});

export default LayoutReference;
